/**
 * insights-analyzer testids — MUI-free so specs and node-side tests can import
 * without pulling React (mirrors funnel-insights/testIds.ts idiom).
 */

export const TRUST_CHIP_TEST_IDS = {
  chip: 'insight-trust-chip',
  popover: 'insight-trust-popover',
} as const;

/** Per-entity chip id when a surface renders many chips (list rows, tree rows). */
export const trustChipTestId = (insightId: string): string => `insight-trust-chip-${insightId}`;
